/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Lastupdatedon3Inputs */

const id_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terakhir diperbarui pada`)
};

const ms_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas kini terakhir pada`)
};

const da_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst opdateret den`)
};

const de_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt aktualisiert am`)
};

const en_us2_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated on`)
};

const es_es2_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización el`)
};

const es_mx2_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización el`)
};

const fil_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling na-update noong`)
};

const fr_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour le`)
};

const it_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento il`)
};

const hu_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utoljára frissítve`)
};

const nl_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt op`)
};

const no_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sist oppdatert`)
};

const pl_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja`)
};

const pt_br2_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização em`)
};

const pt_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização em`)
};

const ro_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizare pe`)
};

const fi_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi päivitetty`)
};

const sv_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad`)
};

const vi_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật lần cuối vào`)
};

const tr_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son güncelleme`)
};

const cs_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední aktualizace`)
};

const bg_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последно актуализирано на`)
};

const ru_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее обновление`)
};

const uk_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останнє оновлення`)
};

const ar_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تحديث في`)
};

const hi_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम अपडेट`)
};

const th_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตล่าสุดเมื่อ`)
};

const ja_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新日`)
};

const zh_cn2_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后更新于`)
};

const zh_hant1_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後更新於`)
};

const ko_offerdetail_reviews_lastupdatedon3 = /** @type {(inputs: Offerdetail_Reviews_Lastupdatedon3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 업데이트일`)
};

/**
* | output |
* | --- |
* | "Last updated on" |
*
* @param {Offerdetail_Reviews_Lastupdatedon3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_lastupdatedon3 = /** @type {((inputs?: Offerdetail_Reviews_Lastupdatedon3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Lastupdatedon3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "da") return da_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "de") return de_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "it") return it_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "no") return no_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "th") return th_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_lastupdatedon3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_lastupdatedon3(inputs)
	return ko_offerdetail_reviews_lastupdatedon3(inputs)
});
export { offerdetail_reviews_lastupdatedon3 as "offerDetail.reviews.lastUpdatedOn" }